/**
 * @generated SignedSource<<83b4b69f3406771916980658cdf985f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type groupHeader_issueTableGrouping$data = {
  readonly fieldType: string | null | undefined;
  readonly fieldValue: {
    readonly __typename: string;
    readonly sprint?: {
      readonly state: JiraSprintState | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"assigneeGroupHeader_issueTableGrouping" | "categoryGroupHeader_issueTableGrouping" | "goalGroupHeader_issueTableGrouping" | "issueTypeGroupHeader_issueTableGrouping" | "labelGroupHeader_issueTableGrouping" | "priorityGroupHeader_issueTableGrouping" | "sprintGroupHeader_issueTableGrouping" | "statusGroupHeader_issueTableGrouping" | "storyPointsGroupHeader_issueTableGrouping">;
  } | null | undefined;
  readonly id: string;
  readonly issueCount: number | null | undefined;
  readonly " $fragmentType": "groupHeader_issueTableGrouping";
};
export type groupHeader_issueTableGrouping$key = {
  readonly " $data"?: groupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "groupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "fieldType"
    },
    {
      "kind": "ScalarField",
      "name": "issueCount"
    },
    {
      "kind": "LinkedField",
      "name": "fieldValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "FragmentSpread",
          "name": "priorityGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "assigneeGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "statusGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "categoryGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "sprintGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "storyPointsGroupHeader_issueTableGrouping"
        },
        {
          "kind": "FragmentSpread",
          "name": "goalGroupHeader_issueTableGrouping"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "labelGroupHeader_issueTableGrouping"
            },
            {
              "kind": "FragmentSpread",
              "name": "issueTypeGroupHeader_issueTableGrouping"
            }
          ]
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "sprint",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "state"
                }
              ]
            }
          ],
          "type": "JiraJqlSprintFieldValue"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroup"
};

(node as any).hash = "1773ecff0aed76f5630de23768df57fd";

export default node;
